import { Component, Input, Output, ChangeDetectionStrategy, EventEmitter } from "@angular/core";
import { FormOption } from 'core'
import { Observable } from "rxjs";
import { map, shareReplay, take } from "rxjs/operators"


@Component({
  selector: "fast-multiselect-option",
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="select__opt"
      [ngClass]="{ 
        selectable: !option.disabled, 
        disabled: option.disabled 
      }"
      (click)="toggleSelect()"
    >
      <input type="checkbox" class="select__opt-checkbox"
        [checked]="selected$ | async"
        [disabled]="option.disabled"
      >
      <div class="select__opt-label">{{ option.label }}</div>
      <div class="select__opt-sub-label" *ngIf="option.subLabel">{{ option.subLabel }}</div>
    </div>
  `
})
export class FastMultiselectOptionComponent {
  @Input() selectedValues$: Observable<any[]>
  @Input() option: FormOption
  @Output('selectOption') selectOptionEmitter = new EventEmitter<FormOption>()
  @Output('deselectOption') deselectOptionEmitter = new EventEmitter<FormOption>()

  selected$: Observable<boolean>

  ngOnInit() {
    this.selected$ = this.selectedValues$.pipe(
      map((values: any[]) => values.indexOf(this.option.value) != -1),
      shareReplay(1)
    )
  }

  toggleSelect() {
    this.selected$.pipe(
      take(1)
    ).subscribe(selected => {
      if (selected) {
        this.deselectOptionEmitter.next(this.option)
      } else {
        this.selectOptionEmitter.next(this.option)
      }
    })
  }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./app/common/forms/fast-multiselect/fast-multiselect-option.component.ts